module.exports = __webpack_public_path__ + "c629ca7d6e3090d08d3503d416b7fe3a.svg";